import React from 'react'

function CardWaveFlat({bgColor = "white", strokeColor="#0044c6", small=false}) {
  return (
      <svg className='wave-separator' {...(small ? { viewBox: "0 0 366 16" } : {})} preserveAspectRatio="xMinYMax meet" height="16" /*viewBox="0 0 366 16"*/ fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* <mask id="mask0_3853_182588" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="366" height="16">
              <rect width="366" height="16" fill="#D9D9D9" />
          </mask> */}
          {/* <g mask="url(#mask0_3853_182588)">
              <g filter="url(#filter0_dd_3853_182588)"> */}
                  <rect width="100%" height="16" fill={bgColor} />
              {/* </g> */}
              <rect width="100%" height="6" fill={strokeColor} />
          {/* </g> */}
          <defs>
              <filter id="filter0_dd_3853_182588" x="-24" y="-12" width="414" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy="12" />
                  <feGaussianBlur stdDeviation="12" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3853_182588" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="1" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
                  <feBlend mode="normal" in2="effect1_dropShadow_3853_182588" result="effect2_dropShadow_3853_182588" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3853_182588" result="shape" />
              </filter>
          </defs>
      </svg>    
  )
}

export default CardWaveFlat